var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{class:_vm.topBannerClass},[_vm._t("default"),_vm._v(" "),(_vm.enableBottomDivider)?_c('div',{staticClass:"divider-white--bottom"}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }